function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.1904 20.61C12.1544 20.61 14.0741 20.0276 15.707 18.9365C17.34 17.8454 18.6127 16.2945 19.3643 14.4801C20.1158 12.6656 20.3119 10.669 19.9287 8.74276C19.5456 6.81653 18.6006 5.04718 17.2119 3.65844C15.8232 2.26971 14.0532 1.32396 12.127 0.940805C10.2007 0.557654 8.20412 0.754306 6.38965 1.50588C4.57518 2.25746 3.02472 3.53022 1.93359 5.1632C0.842471 6.79618 0.259766 8.71603 0.259766 10.68C0.278098 13.3079 1.3302 15.823 3.18848 17.6813C5.04675 19.5396 7.56249 20.5917 10.1904 20.61Z",
  fill: "#AFC3D5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.07031 7.56006L13.3096 13.8001",
  stroke: "#1C2A40",
  strokeWidth: 1.4173,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3096 7.56006L7.07031 13.8001",
  stroke: "#1C2A40",
  strokeWidth: 1.4173,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgCloseIcon = function SvgCloseIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CloseIcon.844258d8.svg";
export { ForwardRef as ReactComponent };